import axios from "axios";
import Qs from "qs";
import constant from "@/common/constant";
import AccessUtil from "@/common/AccessUtil";
import { Toast, Dialog } from "vant";

const CancelToken = axios.CancelToken;
let source = CancelToken.source();

let service = axios.create({
  baseURL: `//${process.env.VUE_APP_HOUSE_API}`,
  // baseURL : 'http://172.16.20.208:9004/'

  // timeout: 15000
});
let loadingContainer = null;
let needLoadingRequestCount = 0;

function startLoading() {
  loadingContainer = document.createElement("div");
  loadingContainer.setAttribute(
    "style",
    "position: fixed; top: 0; width: 100%; height: 100%;background: #000; opacity: 0.3; z-index: 1000;"
  );
  loadingContainer.innerHTML =
    "<svg viewBox='25 25 50 50' class='van-loading__circular' style='width: 60px; color: #C9C9C9; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);'><circle cx='50' cy='50' r='20' fill='none'></circle></svg>";
  document.body.appendChild(loadingContainer);
}

function closeLoading() {
  document.body.removeChild(loadingContainer);
  loadingContainer = null;
}

function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }

  needLoadingRequestCount++;
}

function hideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) {
    return;
  }

  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    closeLoading();
  }
}

function iswhere() {
  let userAgent = navigator.userAgent;
  // console.log(userAgent)
  if (userAgent.match(/app_szxc/)) {
    return "app";
  } else if (
    userAgent.match(/MicroMessenger/) &&
    window.__wxjs_environment != "miniprogram"
  ) {
    return "weixin";
  } else if (window.__wxjs_environment === "miniprogram") {
    return "mini";
  } else {
    return "h5";
  }
}

function getString(name) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  if (window.location.hash.indexOf("?") < 0) {
    return null;
  }
  let r = window.location.hash.split("?")[1].match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return null;
}

function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  // console.log(location.hash.substr(1).match(reg))
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}

function isAndroid() {
  let userAgent = navigator.userAgent;
  return userAgent.match(/app_szxc/);
}

function removeURLParameter(url, parameter) {
  var urlparts = url.split("?");
  if (urlparts.length >= 2) {
    //参数名前缀
    var prefix = encodeURIComponent(parameter) + "=";
    var pars = urlparts[1].split(/[&;]/g);

    //循环查找匹配参数
    for (var i = pars.length; i-- > 0; ) {
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        //存在则删除
        pars.splice(i, 1);
      }
    }

    return urlparts[0] + (pars.length > 0 ? "?" + pars.join("&") : "");
  }
  return url;
}

service.interceptors.request.use(
  function(config) {
    if(!config.noloading)showFullScreenLoading();
    // console.log(token);
    let token = getQueryString("token");

    if (!token) {
      // token = this.$route.query.token;
      token = getString("token");
    }

    if (token) {
      AccessUtil.setAuthToken(token);
      config.headers["X-Auth-Token"] = token;
      // config.headers["X-Auth-Token"] = null;
    } else if (AccessUtil.getAuthToken() != null) {
      config.headers["X-Auth-Token"] = AccessUtil.getAuthToken();
    } else {
      config.headers["X-Auth-Token"] = null;
    }

    // config.headers["X-Auth-Token"] = '95181d10d0e746d4a3988d714d89f855';
    // config.headers["X-App-Key"] = process.env.VUE_APP_APP_KEY;

    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  function(response) {
    hideFullScreenLoading();

    if (response.data == null) {
      return Promise.reject("Null response");
    }

    if (response.data.code === constant.RESPONSE_CODE_LIST.SUCCESS) {
      return response.data;
    } else if (
      response.data.code === constant.RESPONSE_CODE_LIST.TOKEN_INVALID ||
      response.status == 10001 ||
      response.code === 401
    ) {
      var ua = navigator.userAgent.toLowerCase();

      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
            let url = location.href;
            if (url.includes("token")) {
              url = removeURLParameter(url, "token");
              console.log(url);
            }

            // Dialog.confirm({
            //     title: '提示',
            //     message:
            //         '您还没有登录或登录已超时，请重新登录！',
            // })
            //     .then(() => {
            //         wx.miniProgram.redirectTo({
            //             url: "../login/index?callback=" + encodeURIComponent(url)
            //         });
            //     })
            //     .catch(() => {
            //         wx.miniProgram.switchTab({
            //             url: "../index/index"
            //         });
            //     });

            // wx.miniProgram.redirectTo({
            //     url: "../login/index?callback=" + encodeURIComponent(url)
            // });
            wx.miniProgram.navigateTo({
              url: "../login/index?callback=" + encodeURIComponent(url),
            });
          } else {
            Toast(response.data.message);
          }
        });
      } else {
        // let url = location.href;
        // if(url.includes('token')) {
        //    url = removeURLParameter(url, 'token');
        //    console.log(url);
        // }
        Toast(response.data.message);
      }

      let baseUrl = process.env.VUE_APP_BASE_URL;
      let reg = new RegExp("/$"); // eslint-disable-line
      if (reg.test(process.env.VUE_APP_BASE_URL)) {
        baseUrl = process.env.VUE_APP_BASE_URL.substring(
          0,
          process.env.VUE_APP_BASE_URL.length - 1
        );
      }
      let is_android = isAndroid();
      if (is_android) {
        jsMessage.tokenFail();
      }
      // location.href = baseUrl + "/login";
    } else if (
      response.data.code !== constant.RESPONSE_CODE_LIST.SUCCESS &&
      response.data.code !== constant.RESPONSE_CODE_LIST.TOKEN_INVALID
    ) {
      Toast(response.data.message);
      return response.data;
    } else {
      return Promise.reject("未知错误");
    }
  },
  function(error) {
    hideFullScreenLoading();

    Toast(response.data.message);

    return Promise.reject(error);
  }
);

export default {
  getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  },
  get(url, param,noloading=false) {
    return new Promise((resolve, reject) => {
      service({
        method: "get",
        url,
        params: param,
        cancelToken: source.token,
        noloading: noloading,
      })
        .then((response) => {
          //   console.log("response111", response);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  get2(url, param, data) {
    return new Promise((resolve, reject) => {
      service({
        method: "get",
        headers: {
          "Content-Type": "application/json",
        },
        url,
        params: param,
        data: data,
        cancelToken: source.token,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  post(url, param, data) {
    return new Promise((resolve, reject) => {
      service({
        method: "post",
        url,
        params: param,
        data: data,
        cancelToken: source.token,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  post2(url, param, data) {
    return new Promise((resolve, reject) => {
      service({
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        url,
        params: param,
        data: data,
        cancelToken: source.token,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  post3(url, param, data) {
    data = Qs.stringify(data);
    console.log(data);
    return new Promise((resolve, reject) => {
      service({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        url,
        params: param,
        data: data,
        cancelToken: source.token,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  postMultipart(url, param, data) {
    const formData = new FormData();
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        formData.append(key, data[key]);
      }
    }

    return new Promise((resolve, reject) => {
      service({
        method: "post",
        url,
        params: param,
        data: formData,
        cancelToken: source.token,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postAllImage(url, param, data) {
    // const formData = new FormData();
    // for (const key in data) {
    //   if (data.hasOwnProperty(key)) {
    //     formData.append(key, data[key]);
    //   }
    // }

    return new Promise((resolve, reject) => {
      service({
        method: "post",
        url,
        params: param,
        data: data,
        cancelToken: source.token,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  put(url, param, data) {
    return new Promise((resolve, reject) => {
      service({
        method: "put",
        url,
        params: param,
        data: data,
        cancelToken: source.token,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delete(url, param, data) {
    return new Promise((resolve, reject) => {
      service({
        method: "delete",
        url,
        params: param,
        data: data,
        cancelToken: source.token,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
    iswhere
};
